// extracted by mini-css-extract-plugin
export default {"formContainer":"Payment_formContainer__tv8I4","form-container":"Payment_form-container__jZqX+"};